import { EventTypeFilter } from '../types/ViewModel/EventTypeFilter';
import { EventTypeFilterBM } from '../types/BusinessModel/EventTypeFilterBM';

export class EventTypeFilterFactory {
    constructor() {}

    public newEventTypeFilterList(evTypeFilterListBM: EventTypeFilterBM[]): EventTypeFilter[] {
        const evTypeFilterList: EventTypeFilter[] = [];
        if (evTypeFilterListBM && evTypeFilterListBM.length > 0) {
            evTypeFilterListBM.map((cmItem) => {
                evTypeFilterList.push(this.createEventTypeFilterItem(cmItem));
            });
        }
        return evTypeFilterList;
    }

    private createEventTypeFilterItem(item: EventTypeFilterBM): EventTypeFilter {
        return new EventTypeFilter(item.eventTypeFilterId, item.filterHeading, item.eventTypeIdList);
    }
}
